<div class="tab-pane" role="tabpanel" id="disposicion">
    <fieldset id="agregar_disposicion" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Disposiciones Especiales a las que se acogera la Edificación a Regularizar</strong></h3>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group" align="left">
                                <div class="col-md-2">
                                    <mat-checkbox id="disposicion1" name="disposicion1" formControlName="disposicion1" (change)="add_disposicion()" value="SI">Art. 55 LGUC</mat-checkbox>
                                </div>
                                <div class="col-md-4">
                                    <mat-checkbox id="disposicion2" name="disposicion2" formControlName="disposicion2" (change)="add_disposicion()" value="SI">Ley 17.288 Monumentos Nacionales</mat-checkbox>
                                </div>
                                <div class="col-md-4">
                                    <mat-checkbox id="disposicion3" name="disposicion3" formControlName="disposicion3" (change)="add_disposicion()" value="SI">Ley N° 19.537 Copropiedad Inmobiliaria</mat-checkbox>
                                </div>
                                <div class="col-md-2">
                                    <mat-checkbox id="disposicion4" name="disposicion4" formControlName="disposicion4" (change)="add_disposicion()" value="SI">Otro</mat-checkbox>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>